import React from "react";
import { Box, styled } from "@mui/material";

const Container = styled(Box)`
  display: block;
  margin: 0;
  padding: 0;
  padding-right: 5px;
  max-width: calc(100% - 5px);
  height: "100%";
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const TextFieldWithEllipsis = ({
  sx = {},
  children,
}) =>(
    <Container sx={sx}>
      {children}
    </Container>
  );
